import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation EmotionDelete($uid: String!){
        emotion_delete (uid: $uid) {
            success
        }
    }
`;

export async function emotionDelete(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ emotion_delete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.emotion_delete;
}
